import { acrobaseApi } from "@/store/services/acrobase";
import { climateMetricsApi } from "@/store/services/climateMetrics";
import { facadesApi } from "@/store/services/facades";
import { internalApi } from "@/store/services/internal";
import { metabaseApi } from "@/store/services/metabase";
import { supabaseApi } from "@/store/services/supabase";
import type { Middleware } from "redux";

const apis = [acrobaseApi, climateMetricsApi, facadesApi, internalApi, metabaseApi, supabaseApi];

export const services = {
  middlewares: apis.map(({ middleware }) => middleware as Middleware),
  reducers: apis.reduce((reducers, { reducerPath, reducer }) => {
    return { ...reducers, [reducerPath]: reducer };
  }, {}),
};
